import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const FormActions = memo(({ actions, actionsStyle }) => {
  const { styles } = useStyle();
  return (
    <View style={[styles.formActionsContainer, actionsStyle && actionsStyle]}>
      {actions
        .map((item, index) => {
          const isCustomeAction = item.variant === 'custom';
          return isCustomeAction ? (
            item.children
          ) : (
            <Button style={styles.formActionContainer} {...item} />
          );
        })
        .reduce((prev, current) => [prev, <Space size={16} />, current])}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  formActionContainer: {
    flex: 1,
  },
  formActionsContainer: {
    flexDirection: 'row',
  },
}));
